import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { getServiceIcon, getServiceLabel } from "../../utils/serviceIcons";

interface ServiceIconProps {
  serviceName: string;
  size?: number;
}

const ServiceIcon: React.FC<ServiceIconProps> = ({
  serviceName,
  size = 48,
}) => {
  const [imgError, setImgError] = useState(false);
  const { iconUrl, color, bgTint } = getServiceIcon(serviceName);
  const label = getServiceLabel(serviceName);
  const imgSize = Math.round(size * 0.6);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        bgcolor: bgTint,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {iconUrl && !imgError ? (
        <img
          src={iconUrl}
          alt={serviceName}
          width={imgSize}
          height={imgSize}
          style={{ objectFit: "contain" }}
          onError={() => setImgError(true)}
        />
      ) : (
        <Typography
          variant="caption"
          sx={{ color, fontWeight: 700, fontSize: size * 0.25 }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default ServiceIcon;
